// These variables are set by Webpack's DefinePlugin
/* global ENV */
// ENV - production, preview, beta, development or local, or test (when run by jest)
import loglevel from 'loglevel';

const logger = loglevel.getLogger('src');
if (ENV === 'production' || ENV === 'test') {
  logger.setLevel(loglevel.levels.WARN);
} else if (ENV === 'preview') {
  logger.setLevel(loglevel.levels.INFO);
} else {
  logger.setLevel(loglevel.levels.TRACE);
}

export default logger;
